import { schema } from 'normalizr'

const restaurantList = new schema.Entity('restaurantLists')

export default restaurantList
